import React, { useState, useEffect, useRef } from "react";
import { Grid, Button, Box } from "@material-ui/core";

import "./style.css";

import getParameterByName from "../../../../Functions/functions";
import axios from "axios";

import Handsontable from "handsontable";
import "handsontable/dist/handsontable.full.min.css";
import { HotTable } from "@handsontable/react";
import { registerAllModules } from "handsontable/registry";
import { parseDDMMYYYY } from "../../../../Functions/dateParsingFunction";

registerAllModules();

const Provice_Stamp_Duty_Table = ({ formState, setFormState, show, reviwerFlag, role }) => {
  const tableData = {
    rowId: "",
    accountId: 0,
    invoice_Id: Number(formState.invoice_Id), // number for departCord
    glAccount: undefined,
    accountType: "Debit",
    costCenter: "",
    costCenterOwner: "",
    costCenterOwnerName: "",
    wbsElement: "",
    horizonId: "",
    vendor_Code: "",
    amount: 0,
    profitCenter: "",
    department: "",
    description: `${formState.invoice_Desc}`,
  };

  const invoiceId = getParameterByName("invoiceId");


  const addInput = () => {
    const num = Math.random();
    tableData.rowId = num;
    setFormState((formState) => ({
      ...formState,
      invoice_Accounts_list: [...formState.invoice_Accounts_list, tableData],
    }));
  };

  const hotRef = useRef(null);
  const [columns, setColumns] = useState([]);
const [rentGrowthTableData, setRentGrowthTableData] = useState([
  { rentPerMonth: 0, noOfMonths: 0, amount: 0 }, // initial row
]);

  const columnHeaders = [
    "Province",
    "Stamp Duty Rate",
   
   
  ];

  const [stampDutyTableData, setStampDutyTableData] = useState([
  {
    province: "",
    stampDutyRate: "",
   
  }]
);

useEffect(() => {
  const provinceData = formState?.provinceDuty?.[0]; // Safely get the first element

  if ((provinceData?.province || provinceData?.Province) && (provinceData?.stampDutyRate || provinceData?.StampDutyRate)) {
    const updatedData = [...stampDutyTableData];

    updatedData[0] = {
      ...updatedData[0],
      province: provinceData?.province || provinceData?.Province,
      stampDutyRate: provinceData?.stampDutyRate || provinceData?.StampDutyRate,
    };

    setStampDutyTableData(updatedData);
  }
}, [formState?.provinceDuty]);




const agreementTableColumns = [
 
  { data: "province", type: "text", readOnly: true },
  { data: "stampDutyRate", type: "text", readOnly: true },
 

];


  const handleBeforeChange = (changes, source) => {
    if (source == "CopyPaste.paste" && changes[0][1] == 1)
      changes[0][3] = changes[0][3] = changes[0][3].replaceAll(",", "").trim();
  };

const handleAfterChange = (changes, source) => {
    
  if (!changes || source === "loadData") return;

  const newData = [...stampDutyTableData];
  let hasUpdate = false;

  changes.forEach(([rowIndex, prop, oldVal, newVal]) => {
    const row = newData[rowIndex];
  

    // 1️⃣ Calculate % Increase or Decrease
    const last = parseFloat(row.lastRent);
    const current = parseFloat(row.newRent);
    if ((prop === "lastRent" || prop === "newRent") && !isNaN(last) && last !== 0 && !isNaN(current)) {
      const diff = current - last;
      const percent = Math.abs((diff / last) * 100).toFixed(0);
      row.increase = diff > 0 ? `${percent}% ↑` : diff < 0 ? `${percent}% ↓` : "0%";
      hasUpdate = true;
    }

    // 2️⃣ Calculate New Rent Period (Months)
if (prop === "agreementStartDate" || prop === "agreementEndDate") {
  const fromDate = parseDDMMYYYY(row.agreementStartDate);
  const toDate = parseDDMMYYYY(row.agreementEndDate);

  if (!isNaN(fromDate) && !isNaN(toDate)) {
    const diffInMs = toDate - fromDate;
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24)) + 1;

    // Convert days into months (approximate: 30 days = 1 month)
    const months = Math.floor(diffInDays / 30);

    row.tenure = months;
    hasUpdate = true;
  }
}


    // 3️⃣ Calculate New Rent Amount
    if (
      (prop === "newRent" || prop === "from" || prop === "to") &&
      !isNaN(row.newRent) &&
      !isNaN(row.period)
    ) {
      row.newRentAmount = Math.round(row.newRent * row.period);
      hasUpdate = true;
    }
  });

  
    setStampDutyTableData(newData);
  
};
const handleBeforeRemoveRow = (a, b, c, d, e, f) => {
    let tempArr = formState.invoice_Accounts_list;
    for (let index = 0; index < c.length; index++) {
      const rowIndex = c[index];
      const rowId = formState.invoice_Accounts_list[rowIndex].rowId;
      tempArr = tempArr.filter((x) => x.rowId !== rowId);
    }
    setFormState((formState) => ({
      ...formState,
      invoice_Accounts_list: tempArr,
    }));
  };

  return (
    <Grid container>
      <Grid
  item
  xs={12}
  sm={12}
  md={6}
  lg={6}
  style={{ width: "100%", zIndex: "0" }} // ← FIXED!
>

        {/* <Stack sx={{ width: "100%", color: "grey.500" }} spacing={2}>
             <LinearProgress color="info" />
             <LinearProgress color="info" />
             <LinearProgress color="info" />
  </Stack> */}
        <HotTable
          data={stampDutyTableData}
          colHeaders={
       columnHeaders
          }
          columns={agreementTableColumns}
          manualRowResize={true}
          manualColumnResize={true}
          rowHeaders={true}
          height="120"
          rowHeaderWidth={25}
        cells={(row, col) => {
  const cellProperties = {};
  cellProperties.renderer = function (instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.TextRenderer.apply(this, arguments); // draw the value
    td.style.backgroundColor = "#F0F0F0"; // gray background
    return td;
  };
  return cellProperties;
}}

          contextMenu={true}
          filters={true}
          width="100%"
        stretchH="all"
          readOnly={reviwerFlag}
          dropdownMenu={true}
          ref={hotRef}
          beforeChange={handleBeforeChange}
          beforeRemoveRow={handleBeforeRemoveRow}
          afterChange={handleAfterChange}
          licenseKey="non-commercial-and-evaluation" // for non-commercial use
        />

       
      </Grid>
    </Grid>
  );
};

export default React.memo(Provice_Stamp_Duty_Table);
